import React from "react";

function transposeText(text: string): string {
  return text.replace(/[А-Яа-яЁёA-Za-z|]+/g, (word) => {
    if (!word.includes("|")) return word.toLowerCase();

    return word.split("|").reverse().join("|").toLowerCase();
  });
}

function transposeTextType2(text: string): string {
  return text
    .split("|")
    .map((part) => {
      if (part.length <= 1) return part;

      const chars = part.split("");

      [chars[0], chars[chars.length - 1]] = [chars[chars.length - 1], chars[0]];

      return chars.join("");
    })
    .join("|")
    .toLowerCase();
}

type RenderBoardProps = {
  gameRounds: {
    textBySyllables: string[];
    correctAnswer: string;
  }[];
  roundCount: number;
  showSyllables: boolean;
  type: string;
};
const RenderBoard = ({
  gameRounds,
  roundCount,
  showSyllables,
  type,
}: RenderBoardProps) => {
  const currentRound = gameRounds[roundCount];
  const transposedText = currentRound.textBySyllables.map((line) => {
    if (type === "1") {
      return transposeText(line);
    } else if (type === "2") {
      return transposeTextType2(line);
    }
    return line;
  });

  return (
    <div className="transpos-board-grid">
      {transposedText.map((line, index) => (
        <div key={index} className="transpos-text-line">
          {showSyllables
            ? line.split("|").map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr.length - 1 && (
                    <span className="transpos-divider">|</span>
                  )}
                </React.Fragment>
              ))
            : line.replace(/\|/g, "")}
        </div>
      ))}
    </div>
  );
};
export default RenderBoard;
